import { render } from "./VerifyMentorPage.vue?vue&type=template&id=194ab280&scoped=true"
import script from "./VerifyMentorPage.vue?vue&type=script&lang=js"
export * from "./VerifyMentorPage.vue?vue&type=script&lang=js"

import "./VerifyMentorPage.vue?vue&type=style&index=0&id=194ab280&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194ab280"]])

export default __exports__